import { defaultTheme as theme } from '@hn-ui/themes';
var WeeklyTargetLegend = {
    not_started: {
        color: theme.colors.black90,
        title: 'not started',
    },
    started: {
        color: theme.colors.yellow90,
        title: 'started',
    },
    over_halfway: {
        color: "repeating-linear-gradient(\n    -45deg,\n    " + theme.colors.yellow90 + " 0 4px,\n    " + theme.colors.green60 + " 4px 6px\n  )",
        title: 'over halfway',
    },
    completed: {
        color: theme.colors.green70,
        title: 'completed',
    },
};
var WeeklyTargetCompletion = {
    not_started: {
        color: 'transparent',
        borderColor: theme.colors.black90,
        angle: 100,
    },
    started: {
        color: theme.colors.yellow70,
        borderColor: theme.colors.yellow70,
        angle: 25,
    },
    over_halfway: {
        color: theme.colors.yellow70,
        borderColor: theme.colors.yellow70,
        angle: 75,
    },
    completed: {
        color: theme.colors.green60,
        borderColor: theme.colors.green60,
        angle: 100,
    },
};
var WEEKLY_LEGEND_STATUSES = [
    'not_started',
    'started',
    'over_halfway',
    'completed',
];
var WEEKLY_BAR_STATUSES = WEEKLY_LEGEND_STATUSES.slice().reverse();
export { WeeklyTargetLegend, WEEKLY_LEGEND_STATUSES, WEEKLY_BAR_STATUSES, WeeklyTargetCompletion, };
